module.exports = __webpack_public_path__ + "media/images/CHA-01-d32d67f0053abeff6ff5a7c43d293fb6.jpg";